import vuexI18n from 'vuex-i18n';
import en from '../i18n/en.json';
import ru from '../i18n/ru.json';

export default {
  install: (Vue, { state }) => {
    Vue.use(vuexI18n.plugin, state.store);
    Vue.i18n.add('en', en);
    Vue.i18n.add('ru', ru);
    Vue.i18n.fallback('en');
    Vue.i18n.set('en');

    Vue.prototype.$t = Vue.i18n.translate;
  }
}



// WEBPACK FOOTER //
// ./src/plugins/i18n.plugin.js